import axios from "axios";

import { IJournalIndicatorsItem } from "./types";

export const journalIndicatorsApi = {
  get: (buildingId: string, params: { year: number; month: number }) => {
    return axios.get<IJournalIndicatorsItem[]>(`/journal/${buildingId}/indicators/`, { params });
  },
};
